//MailingLabels.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

import { Button, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React from "react";
import ReactDOM from "react-dom/client";

const convertAddressToMixedCase: boolean = true;

interface iLayout {
   marginLeft: number;
   paddingLeft: number;
   labelWidth: number;
   gapWidth: number;

   marginTop: number;
   paddingTop: number;
   labelHeight: number;

   numRow: number;
   numCol: number;
   fontSize: number;
   lineSpacing: number;
   maxCharPerLine: number;
}
let layout: iLayout;

interface iAddress {
   name?: string; // Owner name.
   address?: string; // Mailing address.
   cityStateZip?: string; // Mailing city, state, zip.
   sortValue?: string; // Value to sort on.
}
let addresses: iAddress[] = [];

//Show the dialog.
export function show() {
   if (!Settings.dialogDivRoot) {
      Settings.setDialogDivRoot(ReactDOM.createRoot(document.getElementById("dialog_div")));
   }
   Settings.dialogDivRoot.render(<Render key={Util.uid()} />);
}

//Create mailing labels.
function createLabels(labelType: string) {
   setLayout(labelType);
   loadAddressArray();
   createPDF(labelType);
}

//Load the address array.
function setLayout(labelType: string) {
   if (labelType === "5160") {
      layout = {
         marginLeft: 0.2,
         paddingLeft: 0.15,
         labelWidth: 2.63,
         gapWidth: 0.14,

         marginTop: 0.5,
         paddingTop: 0.3,
         labelHeight: 1,

         numRow: 10,
         numCol: 3,
         fontSize: 9,
         lineSpacing: 0.16,
         maxCharPerLine: 36,
      };

   } else if (labelType === "5161") {
      layout = {
         marginLeft: 0.2,
         paddingLeft: 0.15,
         labelWidth: 4,
         gapWidth: 0.2,

         marginTop: 0.5,
         paddingTop: 0.28,
         labelHeight: 1,

         numRow: 10,
         numCol: 2,
         fontSize: 10,
         lineSpacing: 0.18,
         maxCharPerLine: 50,
      };
   }
}

//Load the address array.
function loadAddressArray() {
   const lay: Search.iLayer = Search.layers[Search.activeLayerIndex];
   const fs = lay.fs;
   addresses = [];
   let value: string;

   for (const feature of fs.features) {
      const rec: iAddress = {};

      //Owner name fields.
      let name: string = "";

      for (const settingField of Settings.mailLabel.nameFields) {
         if (settingField.toLowerCase() === "ampersand") {
            name += " &";

         } else {
            value = Util_App.getFieldValueNoCase(settingField, feature, fs) as string;
            if (convertAddressToMixedCase) {
               value = value.ToProperCase();
               if (value === "" && name.EndsWith(" &")) {
                  name = name.slice(0, -2);
               }
            }
            name += " " + value;
         }
      }

      rec.name = name.RemoveDouble().trim();

      //Address fields.
      let address: string = "";

      for (const settingField of Settings.mailLabel.addressFields) {
         value = Util_App.getFieldValueNoCase(settingField, feature, fs) as string;
         if (convertAddressToMixedCase) {
            value = value.ToProperCase();
         }
         address += " " + value;
      }
      rec.address = address.RemoveDouble().trim();

      //City state zip fields.
      let cityStateZip: string = "";

      for (const settingField of Settings.mailLabel.cityStateZipFields) {
         if (settingField.toLowerCase() === "comma") {
            cityStateZip += ",";

         } else {
            value = Util_App.getFieldValueNoCase(settingField, feature, fs) as string;
            if (convertAddressToMixedCase) {
               if (typeof value === "string") {
                  value = value.ToProperCase();
               }
            }
            cityStateZip += " " + value;
         }
      }
      rec.cityStateZip = cityStateZip.RemoveDouble().trim();

      //Sort value.
      let sortValue: string = rec.address;

      const sa: string[] = rec.address.split(" ");
      if (sa.length > 1) {
         sortValue = "";
         for (let i = 1; i < sa.length; i++) {
            sortValue += sa[i] + " ";
         }
         sortValue += sa[0];
      }

      rec.sortValue = sortValue.RemoveDouble().trim();

      //Add to array.
      addresses.Add(rec);
   }

   addresses.sort(Util.sortArray("sortValue"));
}

//Create pdf.
function createPDF(labelType: string) {
   //Create new pdf document.

   import("jspdf").then(({ jsPDF }) => {
      const doc = new jsPDF("portrait", "in", "letter");
      doc.setFontSize(layout.fontSize);

      const numPerPage: number = layout.numRow * layout.numCol;
      const numPages: number = Util.parseInteger(((addresses.length + numPerPage - 1) / numPerPage).toString());
      const lineNames: string[] = ["name", "address", "cityStateZip"];
      let n: number = 0;
      let y: number;
      let x: number;
      let y2: number;
      let lines: string[];

      //Process all pages.
      for (let p: number = 0; p < numPages; p++) {
         if (p > 0) {
            doc.addPage();
         }
         y = layout.marginTop + layout.paddingTop;

         //Process all rows.
         for (let r: number = 0; r < layout.numRow; r++) {
            x = layout.marginLeft + layout.paddingLeft;

            //Process all columns.
            for (let c: number = 0; c < layout.numCol; c++) {
               y2 = y;

               //Process all address lines.
               if (n < addresses.length) {

                  for (const lineName of lineNames) {
                     const str = addresses[n][lineName] as string;
                     lines = wordWrap(str, layout.maxCharPerLine);

                     for (const line of lines) {
                        doc.text(line, x, y2);
                        y2 += layout.lineSpacing;
                     }
                  }
               }

               x += layout.labelWidth + layout.gapWidth;
               n += 1;
            }
            if (n >= addresses.length) {
               break;
            }
            y += layout.labelHeight;
         }
      }

      const id: string = Util.uid().SubStr(2, 4);
      doc.save("Mail_Labels_" + labelType + "_" + id + ".pdf");

   }).catch((error: Error) => {
      Util.errMsg('An error occurred while loading the jsPDF module:', error);
   });
}

//Word wrap function. Returns array of strings. brk and Cut are optional.
function wordWrap(str: string, inWidth: number, brk?: string, cut?: boolean): string[] {
   const width: number = inWidth || 75;
   brk = brk || '|';
   cut = cut || false;

   if (!str) { return [str]; }
   const regex = '.{1,' + width + '}(\\s|$)' + (cut ? '|.{' + width + '}|.+$' : '|\\S+?(\\s|$)');
   const recs = str.match(new RegExp(regex, 'g'));

   const recsTrim: string[] = [];
   for (const rec of recs) {
      recsTrim.Add(rec.trim());
   }
   return recsTrim;
}

//Render function.
export function Render() {

   //Define state.
   const [visible, setVisible] = React.useState(true); //Set refresh method.

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Button click event.
   function handleClick(labelType: string) {
      createLabels(labelType);
      setVisible(false);
   }

   //Close dialog.
   function handleClose() {
      setVisible(false);
   }

   //css styles.
   return (
      <ThemeProvider theme={Default.theme}>
         <CssBaseline />

         <Dialog
            open={visible}
            onClose={handleClose}
            aria-labelledby="mailing-dialog-title"
            aria-describedby="mailing-dialog-description"
         >
            <DialogTitle id="mailing-dialog-title" style={{ paddingBottom: 0, paddingTop: 9 }}>Choose a label style</DialogTitle>

            <DialogContent>
               <div className="app-flex-row-around" style={{ marginBottom: 12 }}>
                  <Button variant="contained" onClick={() => handleClick("5160")} color="primary" title="Layout style 5160" aria-label="5160">
                     Avery 5160
                  </Button>

                  <Button variant="contained" onClick={() => handleClick("5161")} color="primary" title="Layout style 5161" aria-label="5161">
                     Avery 5161
                  </Button>
               </div>

               <DialogContentText id="mailing-dialog-description">
                  Note - Set Adobe Reader page sizing to <br /> &quot;Actual size&quot; before printing
               </DialogContentText>
            </DialogContent>

            <DialogActions>
               <Button onClick={handleClose} color="primary">
                  Close
               </Button>
            </DialogActions>
         </Dialog>
      </ThemeProvider>
   ); //end return.

} //end function.
